import type { RestaurantList } from "../types/restaurant";

// Static list moved from public/restaurants.json for type-safety and tree-shaking
const restaurants: RestaurantList = [
  { name: "House of Mac", type: "American" },
  { name: "Proper Orlando", type: "American" },
  { name: "Rise Biscuits", type: "Breakfast/Brunch" },
  { name: "Fresh Kitchen", type: "American" },
  { name: "Marketplace at Avalon Park", type: "American" },
  { name: "Plant Street Market", type: "American" },
  { name: "Cow and cheese", type: "American" },
  { name: "Chicken fire", type: "Chicken" },
  { name: "Smoke and doughnuts", type: "BBQ/Smokehouse" },
  { name: "Jericho drive through", type: "American" },
  { name: "BAD AS'S BURGERS", type: "Burger" },
  { name: "Charlie's Kitchen & Grill", type: "American" },
  { name: "Willie boys bbq", type: "BBQ/Smokehouse" },
  { name: "Alex's gyro and cheesesteaks", type: "Sandwich" },
  { name: "Beef N' Buns", type: "Sandwich" },
  { name: "Black Bear Kitchen", type: "American" },
  { name: "TooJay's Deli • Bakery • Restaurant", type: "Breakfast/Brunch" },
  { name: "Irregular Smash", type: "Burger" },
  { name: "LoveBird Almost Famous Chicken", type: "Chicken" },
  { name: "Bad As's Sandwich PRIMROSE", type: "Sandwich" },
  { name: "The Whiskey", type: "American" },
  { name: "Kura Sushi", type: "Sushi" },
  { name: "Token Ramen", type: "Ramen/Noodles" },
  { name: "Kazu Sushi Burrito", type: "Sushi" },
  { name: "Kyu Ramen", type: "Ramen/Noodles" },
  { name: "Wa Ramen", type: "Ramen/Noodles" },
  { name: "Zaru", type: "Japanese" },
  { name: "The bao spot", type: "Japanese" },
  {
    name: "mosonori | Japanese handroll sushi bar | Winter Park",
    type: "Sushi",
  },
  { name: "Palm Beach Meats Orlando", type: "Japanese" },
  { name: "Edoboy", type: "Japanese" },
  { name: "The Mongolorian BBQ", type: "BBQ/Smokehouse" },
  { name: "Izziban Sushi & BBQ", type: "Sushi" },
  { name: "Star BBQ Korean", type: "BBQ/Smokehouse" },
  { name: "Kbob Korean Street Food", type: "Korean" },
  { name: "U TURN KOREAN BBQ", type: "BBQ/Smokehouse" },
  { name: "Gogi hotpot", type: "Korean" },
  { name: "92 chicken", type: "Chicken" },
  { name: "Snowbean", type: "Korean" },
  { name: "The Neighborhood Eatery", type: "Korean" },
  { name: "Ma Lu Bian Bian", type: "Korean" },
  { name: "SoGongDong & K-BBQ", type: "BBQ/Smokehouse" },
  { name: "bb.q Chicken East Colonial", type: "Chicken" },
  { name: "Mia's Italian Kitchen", type: "Italian" },
  { name: "V Pizza", type: "Pizza" },
  { name: "Butter Crust Pizza", type: "Pizza" },
  { name: "Dough Boyz Pizzeria", type: "Pizza" },
  { name: "Mister O1 Extraordinary Pizza - Dr. Phillips", type: "Pizza" },
  { name: "Francisco's taco madness", type: "Mexican/Tex-Mex" },
  { name: "Fui Yo Mexicana", type: "Mexican/Tex-Mex" },
  { name: "Superica Winter Park", type: "Mexican/Tex-Mex" },
  { name: "Orinocos Cafe & Bakery", type: "Bakery/Café" },
  { name: "Corazon by Baires", type: "Hispanic" },
  { name: "That Wing Spot", type: "Wings" },
  { name: "My Kitchen Wings & Fish", type: "Wings" },
  { name: "Buffalo Boss", type: "Wings" },
  { name: "Wing alley", type: "Wings" },
  { name: "World Food Trucks", type: "International" },
  { name: "Sticky rice", type: "International" },
  { name: "EggDose", type: "Breakfast/Brunch" },
  { name: "Hawkers Asian Street Food", type: "International" },
  { name: "Alvin's Cuisine", type: "International" },
  { name: "Rion's Ocean Room", type: "Seafood" },
  { name: "True Island Grille", type: "International" },
  { name: "East Garden Chinese Restaurant", type: "Chinese" },
  { name: "Kai Kai BBQ & Dumplings", type: "Chinese" },
  { name: "Ez Eats Afro Soul Food", type: "Soul Food" },
  { name: "Uncle Tony's Backyard bbq", type: "BBQ/Smokehouse" },
  { name: "Kook'n with Kim", type: "Soul Food" },
  { name: "Voodoo Bayou", type: "Soul Food" },
  { name: "Candee Lee's Soul House", type: "Soul Food" },
  { name: "Just Extremely Tasty LLC", type: "Soul Food" },
  { name: "Joury Ice Cream & Cafe", type: "Ice Cream/Gelato" },
  { name: "JoJos Shake Bar", type: "Ice Cream/Gelato" },
  { name: "Swirls on the Water", type: "Ice Cream/Gelato" },
  { name: "Naked Cupcake", type: "Bakery/Café" },
  { name: "Lotte Market", type: "Desserts" },
  { name: "Fluffy Fluffy Dessert Cafe", type: "Desserts" },
  { name: "Chiffon Culture", type: "Bakery/Café" },
  { name: "Donutste", type: "Bakery/Café" },
  { name: "Parkesdale Farm Market", type: "Desserts" },
  { name: "Parlor Doughnuts", type: "Bakery/Café" },
  { name: "Kori Bakery", type: "Bakery/Café" },
  { name: "The Salty Donut", type: "Bakery/Café" },
  { name: "Picasso Moments Bakery, Cafe, & Boba Tea", type: "Bubble Tea/Boba" },
  { name: "Gideon's Bakehouse", type: "Bakery/Café" },
  { name: "Mango Mango Dessert - Orlando", type: "Desserts" },
  { name: "Harmony Tea Shoppe", type: "Bubble Tea/Boba" },
  { name: "Yeast Coast Bakehouse", type: "Bakery/Café" },
  { name: "Peach Cobbler Factory", type: "Bakery/Café" },
  { name: "Alien Treats FL", type: "Desserts" },
  { name: "Nola's Ice Cream", type: "Ice Cream/Gelato" },
  { name: "La Carraia Florida Gelateria", type: "Ice Cream/Gelato" },
  { name: "Gelato Go Winter Garden", type: "Ice Cream/Gelato" },
  { name: "Bacio Ice Cream Shop", type: "Ice Cream/Gelato" },
  { name: "MÖGE TEE - Sandlake", type: "Bubble Tea/Boba" },
  { name: "Saigon Snow", type: "Bubble Tea/Boba" },
  { name: "Picasso Moments Bakery, Cafe, & Boba Tea", type: "Bubble Tea/Boba" },
  { name: "New Leaf Tea House", type: "Bubble Tea/Boba" },
  { name: "The Greenery Creamery", type: "Ice Cream/Gelato" },
  { name: "Frappe Latino", type: "Ice Cream/Gelato" },
  { name: "Bora Bora Smoothie Cafe - Orlando", type: "Ice Cream/Gelato" },
  { name: "The Original Rainbow Cone - Orlando", type: "Ice Cream/Gelato" },
  { name: "McDonald's", type: "Fast Food" },
  { name: "Burger King", type: "Fast Food" },
  { name: "Wendy's", type: "Fast Food" },
  { name: "Taco Bell", type: "Mexican/Tex-Mex" },
  { name: "Chick-fil-A", type: "Chicken" },
  { name: "Popeyes", type: "Chicken" },
  { name: "Chipotle", type: "Mexican/Tex-Mex" },
  { name: "Five Guys", type: "Burger" },
  { name: "Panera Bread", type: "Breakfast/Brunch" },
  { name: "Subway", type: "Sandwich" },
  { name: "Domino's Pizza", type: "Pizza" },
  { name: "Culver's", type: "Fast Food" },
  { name: "Arby's", type: "Sandwich" },
  { name: "Jimmy Johns", type: "Sandwich" },
  { name: "Jersey Mike's", type: "Sandwich" },
  { name: "Little Caesars", type: "Pizza" },
  { name: "Panda Express", type: "Chinese" },
  { name: "Sonic Drive-In", type: "Fast Food" },
  { name: "Dairy Queen", type: "Ice Cream/Gelato" },
  { name: "Wingstop", type: "Wings" },
  { name: "Cava", type: "Fast Food" },
  { name: "Raising Canes", type: "Chicken" },
  { name: "PDQ", type: "Chicken" },
  { name: "Steak n Shake", type: "Burger" },
  { name: "Shake Shack", type: "Burger" },
  { name: "Pizza Hut", type: "Pizza" },
  { name: "Del Taco", type: "Mexican/Tex-Mex" },
  { name: "Charley's Philly Steaks", type: "Sandwich" },
  { name: "Olive Garden", type: "Italian" },
  { name: "Red Lobster", type: "Seafood" },
  { name: "Millers Ale House", type: "Chain Restaurant" },
  { name: "Buffalo Wild Wings", type: "Wings" },
  { name: "Chili's", type: "Chain Restaurant" },
  { name: "TGI Fridays", type: "Chain Restaurant" },
  { name: "Hooters", type: "Wings" },
  { name: "Applebee's", type: "Chain Restaurant" },
  { name: "Bubba Gump Shrimp Co.", type: "Seafood" },
  { name: "Rainforest Cafe", type: "Chain Restaurant" },
  { name: "Giordano's", type: "Pizza" },
  { name: "Smashville Hot Chicken & Burgers", type: "Burger" },
  { name: "Buffalo Boss Brooklyn's Finest Wings", type: "Wings" },
  { name: "Kizuna Asian Buffet & Sushi", type: "Sushi" },
  { name: "AJ's Pizza Joint", type: "Pizza" },
  { name: "Shokupan Bakehouse", type: "Bakery/Café" },
  { name: "@ The Diner", type: "American" },
  { name: "Fresco Cucina Italiana", type: "Italian" },
  { name: "Koko Kakigori", type: "Ice Cream/Gelato" },
  { name: "Dee's Quick Fix - Pasta, Wings, & More", type: "American" },
  { name: "Slam Dunk Sandwiches", type: "Sandwich" },
  { name: "Gen Korean BBQ House", type: "Korean" },
  { name: "Sweet Clicks", type: "Desserts" },
  { name: "Gelato-go Orlando", type: "Ice Cream/Gelato" },
  { name: "Perkins American Food Co.", type: "American" },
  { name: "Tsuri Japanese Street Food", type: "Japanese" },
  { name: "Kingston 5 - Jamaican Fusion Kitchen", type: "International" },
  { name: "Sister Honey's", type: "Bakery/Café" },
  {
    name: "La Fonda Mexican Kitchen & Maya Thai Cuisine - Longwood",
    type: "International",
  },
  {
    name: "SLAP Hand Ripped Noodles",
    type: "Ramen/Noodles",
  },
  { name: "Nando Grill Carne En Vara", type: "Mexican/Tex-Mex" },
  { name: "Licious Noodles & Bao", type: "Chinese" },
  { name: "Southern Fowl", type: "Wings" },
  { name: "Brazilian Bistro", type: "Hispanic" },
  { name: "Sushi Izuki", type: "Sushi" },
  { name: "Dolce and Bake Cafe", type: "Bakery/Café" },
  { name: "Jeff's Bagel Run", type: "Bakery/Café" },
  { name: "Mis Antojitos Street Food", type: "Mexican/Tex-Mex" },
  { name: "Moa Kai", type: "International" },
  { name: "Quesa Loco", type: "Mexican/Tex-Mex" },
  { name: "Mamazzita Gastrobar", type: "Hispanic" },
  { name: "Arcade Time Entertainment", type: "American" },
  { name: "Jala Indian Restaurant", type: "International" },
  { name: "Grain and Berry", type: "American" },
  { name: "Pie Fection", type: "Pizza" },
  { name: "Hong Kong Kitchen", type: "Chinese" },
  { name: "Corner Chophouse", type: "American" },
  { name: "Deeply Cafe and Bottle Shop", type: "Bakery/Café" },
  { name: "H Mart", type: "Korean" },
  { name: "Shaka Donuts", type: "Bakery/Café" },
  { name: "Daniel Gabor's Alpine Bar & Grill", type: "American" },
  { name: "Outpost Neighborhood Tavern", type: "American" },
  { name: "Sparrow", type: "Wine Bar" },
  { name: "Talay", type: "Thai" },
  { name: "Black Coffee/Cafe Negro Bistro", type: "Breakfast/Brunch" },
  { name: "Pho 813", type: "Vietnamese" },
  { name: "Nuri's Tavern", type: "Pizza" },
  { name: "Gyukatsu Rose", type: "Japanese" },
  { name: "Luca Turci Italian Restaurant", type: "Italian" },
  { name: "June", type: "Mexican/Tex-Mex" },
  { name: "The Packwoods", type: "Bar" },
  { name: "The Chapman", type: "American" },
  { name: "Osteria Ester", type: "Italian" },
  { name: "Perla's Pizza", type: "Pizza" },
  { name: "Selva Rosa Cocina & Bar", type: "Mexican/Tex-Mex" },
  { name: "Kappo Tsan", type: "Japanese" },
  { name: "Mazala Pijja", type: "Pizza" },
  { name: "Neko San", type: "Sushi" },
  { name: "Walter's Tavern", type: "American" },
  { name: "Mills Market", type: "Asian" },
  { name: "Yumee Katsu", type: "Japanese" },
  { name: "Sabai Thai Street Food", type: "Thai" },
  { name: "Ming Garden", type: "Chinese" },
  { name: "The Dough Show", type: "Pizza" },
  { name: "The Jersey Spot Pizza and Pasta", type: "Pizza" },
  { name: "Francisca Charcoal Chicken and Meats", type: "Hispanic" },
  { name: "Budsaba Thai Bistro", type: "Thai" },
  { name: "Sushi Saint", type: "Sushi" },
  { name: "Unplugged Social Cafe", type: "Bakery/Café" },
  { name: "Knights Curry Express", type: "International" },
  { name: "Amalfi", type: "Italian" },
  { name: "Tamara Lake Mary", type: "International" },
  { name: "Raine's Pizzeria", type: "Pizza" },
  { name: "Seoul Bōl", type: "Korean" },
  { name: "The Human Bean", type: "Bakery/Café" },
  { name: "Summer Breeze Roti Shop", type: "International" },
];

export default restaurants;
